import { ADMIN_API_BASE } from "./adminApiConfig";
import adminRequest from "./adminRequest";

export type AdminWinnerType = "daily" | "weekly" | "main";

export interface AdminWinnerRow {
  id: number;
  hash?: string | null;
  identity: string;
  name: string | null;
  email: string | null;
  code: string;
  award: string;
  reserve_for: string | null;
  status: string;
  ranking: number;
}

export interface AdminWinnersResponse {
  code: number;
  message: string;
  description?: string;
  data: AdminWinnerRow[];
}

/** Ista mapa kao getWinnersWeekly.ts — nedelja → YYYYMMDD */
export { weeklyDateByWeek } from "./getWinnersWeekly";

/**
 * Admin Dobitnici → GET /api/admin/winners
 * Ne koristi javne /api/ultra/winners* (maskirani, bez rezervi).
 */
const getAdminWinners = async (
  type: AdminWinnerType,
  date: string
): Promise<AdminWinnerRow[]> => {
  try {
    const body = await adminRequest<AdminWinnersResponse>({
      method: "GET",
      url: `${ADMIN_API_BASE}/api/admin/winners`,
      params: { type, date },
    });

    if (body.code !== 200) {
      return [];
    }

    return Array.isArray(body.data) ? body.data : [];
  } catch (error) {
    return [];
  }
};

export default getAdminWinners;
